import { usePcrsConnection } from "features/cdm/hooks/usePcrsConnection";
import { usePCRSSchemeCheck } from "features/cdm/hooks/usePCRSSchemeCheck";
import { useSyncPcrsSchemeCheck } from "features/cdm/hooks/useSyncPcrsSchemeCheck";

// Single entry point for the CDM tab's PCRS integration: runs the scheme check,
// syncs its result to the BE (so eligibility is server-authoritative), and
// manages the credential prompt + patient-details (cdm-ws) connection. Exposes
// only what the page needs.
export const usePcrs = ({ patientId }) => {
  const {
    data: schemeCheck,
    isLoading: isSchemeCheckLoading,
    isFetching: isSchemeCheckFetching,
    refetch: recheckScheme,
  } = usePCRSSchemeCheck({ patientId });

  const {
    cdmPatientDetails,
    isCdmPatientDetailsLoading,
    isCdmPatientDetailsPending,
    hasWsConnection,
    credentialsDialog,
  } = usePcrsConnection({ patientId, schemeCheck });

  // Sync after the connection hook so the details (raw XML + parsed fields) can
  // be posted alongside the scheme check in a single payload once both resolve.
  useSyncPcrsSchemeCheck({
    patientId,
    schemeCheck,
    cdmPatientDetails,
    isCdmPatientDetailsPending,
  });

  return {
    schemeCheck,
    isSchemeCheckLoading,
    // Re-runs the scheme check, e.g. after the user installs the extension.
    recheckScheme,
    isRecheckingScheme: isSchemeCheckFetching,
    cdmPatientDetails,
    isCdmPatientDetailsLoading,
    isCdmPatientDetailsPending,
    hasWsConnection,
    credentialsDialog,
  };
};
